class PreviewGoal {
    investmentRequiredAmount;
    timeWithoutReinvestment;
    timeWithReinvestment;
    timeToGoalReductionWithReinvestment;
    constructor(data) {
        this.investmentRequiredAmount = data.investmentRequiredAmount;
        this.timeWithReinvestment = data.timeWithReinvestment;
        this.timeWithoutReinvestment = data.timeWithoutReinvestment;
        this.timeToGoalReductionWithReinvestment = data.timeToGoalReductionWithReinvestment;
    }
}
export default PreviewGoal;
